export default __webpack_public_path__ + "static/media/codepush.6a115eba.svg";